/* RetryIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import RetryIcon from '@atlaskit/icon/core/retry';
import messages from './messages';
export var RetryIconButton = function RetryIconButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    appearance = _ref.appearance,
    spacing = _ref.spacing,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var tooltip = formatMessage(messages.retryPrompt);
  var tooltipOptions = {
    position: 'top',
    hideTooltipOnClick: true,
    content: tooltip
  };
  return /*#__PURE__*/React.createElement(IconButton, {
    testId: "retry-prompt-button",
    type: "button",
    onClick: onClick,
    icon: RetryIcon,
    label: tooltip,
    appearance: appearance,
    spacing: spacing,
    tabIndex: tabIndex,
    isTooltipDisabled: false,
    tooltip: tooltipOptions,
    isDisabled: isDisabled
  });
};